<!--
 * @Description: 
 * @Author: dezhi
 * @Date: 2020-02-19 15:46:56
 * @LastEditTime: 2022-12-16 17:13:47
 * @LastEditors: zhaoshuai
 -->
<template>
  <div class="wrapper step-box flex sharing-h">
    <div class="exam-info">特许全球金融科技师CGFT（二级）评定报名</div>
    <br />
    <div class="apply-step" v-show="isResult">
      步骤
      <b>{{ order }}</b>
      /6 {{ title }}
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Step",
  props: ["order", "title"],
  data() {
    return {
      isResult: true,
    };
  },
  mounted() {
    const ispay = sessionStorage.getItem("isResult");
    if (ispay != null && ispay == 15) {
      this.isResult = false;
    } else {
      this.isResult = true;
    }
  },
};
</script>

<style>
.step-box {
  background: brown;
}
.apply-step {
  color: rgba(249, 249, 249, 1);
}
.exam-info {
  color: rgba(249, 249, 249, 1);
  font-size: 24px;
  font-weight: 700;
  min-width: 300px;
}
</style>
